import * as types from "./types";

import {
    getOpportunityListAxios,
    deleteOpportunityAxios,
    postOpportunityAxios,
    putOpportunityAxios,
    getOpportunityByIdAxios,
    updateOpportunityStatus,
    getOpportunityPipelines,
    updateOpportunityPipelines
} from "./services";

export async function getOpportunityListAction({ commit }) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        const { data } = await getOpportunityListAxios();
        commit(types.GET_OPPORTUNITIES_LIST, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

export async function removeOpportunitiesAction({ commit }, payload) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        const response = await deleteOpportunityAxios(payload);
        commit(types.REMOVE_OPPORTUNITIES, payload);
        return response;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

export async function addOpportunitiesAction({ commit }, payload) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        const { data } = await postOpportunityAxios(payload);
        commit(types.ADD_OPPORTUNITIES, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

// Vuex action
export async function updateOpportuntiesAction({ commit }, { id, payload }) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        await putOpportunityAxios(id, payload);
        commit(types.UPDATE_OPPORTUNITIES, payload);
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

export async function getOpportunityByIdAction({ commit }, payload) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        const { data } = await getOpportunityByIdAxios(payload);
        commit(types.GET_OPPORTUNITY_ID, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

export async function updateOpportunityStatusAction({ commit }, payload) {
    commit(types.LOADING_OPPORTUNITIES, true);
    console.log('Types:', types); // Should output all the type constants
    console.log('Committing type:', types.UPDATE_OPPORTUNITY_STATUS); // Should output the string "UPDATE_OPPORTUNITY_STATUS"
    console.log('Payload:', payload); // Should output the payload object

    commit(types.UPDATE_OPPORTUNITY_STATUS, payload);
    try {
        await updateOpportunityStatus(payload);

        commit(types.UPDATE_OPPORTUNITY_STATUS, payload);
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}

export async function getPipelineListAction({ commit }) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        const { data } = await getOpportunityPipelines();
        commit(types.GET_PIPELINES_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}


export async function updateOpportunityPipelinesAction({ commit }, payload) {
    commit(types.LOADING_OPPORTUNITIES, true);
    try {
        await updateOpportunityPipelines(payload);
    } catch (e) {
        throw e;
    } finally {
        commit(types.LOADING_OPPORTUNITIES, false);
    }
}